import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box, Button, ButtonText, Text, VStack,
} from '@gluestack-ui/themed';
import type { PendingConfirmation } from './useAssistantStream';

type ConfirmCardProps = {
  pending: PendingConfirmation;
  onConfirm: () => void;
  isLoading?: boolean;
};

/**
 * ConfirmCard
 * ----
 * Renders a destructive-operation preview and confirm action.
 */
const ConfirmCard: React.FC<ConfirmCardProps> = ({ pending, onConfirm, isLoading = false }) => {
  const { t } = useTranslation();
  const sample = pending.previewData?.taskId || pending.input?.taskId;

  return (
    <Box
      bg="$statusWarningSubtle"
      borderLeftWidth={4}
      borderLeftColor="$statusWarning"
      p="$2"
      borderRadius="$sm"
      testID="admin-assistant-confirm-card"
    >
      <VStack space="sm">
        <Text size="sm" fontWeight="semibold" color="$textHeading">
          {t('admin.assistant.confirm.title')}
        </Text>
        {!!pending.summary && (
          <Text size="sm">{pending.summary}</Text>
        )}
        {!!sample && (
          <Text size="xs" color="$textSubtle">
            {t('admin.assistant.confirm.sample', { sample: String(sample) })}
          </Text>
        )}
        <Button
          size="sm"
          action="primary"
          onPress={onConfirm}
          isDisabled={isLoading}
          testID="admin-assistant-confirm-button"
        >
          <ButtonText>{t('admin.assistant.confirm.action')}</ButtonText>
        </Button>
      </VStack>
    </Box>
  );
};

export default ConfirmCard;
